import { render, staticRenderFns } from "./SaveCancelSection.vue?vue&type=template&id=5a791e70&scoped=true"
import script from "./SaveCancelSection.vue?vue&type=script&lang=js"
export * from "./SaveCancelSection.vue?vue&type=script&lang=js"
import style0 from "./SaveCancelSection.vue?vue&type=style&index=0&id=5a791e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a791e70",
  null
  
)

export default component.exports